import React, { useEffect, useState, useRef } from "react";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  FaSearch,
  FaTimes,
  FaTelegram,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
  FaFacebook,
  FaYoutube,
  FaArrowLeft,
  FaBars,
  FaCarSide,
  FaUser,
  FaPhone,
  FaLock,
} from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { Config } from "../../Config";
import Category from "../Category/Category";
import HeaderCartBox from "../HeaderCartBox/HeaderCartBox";
import { emptyCart, removeUser, updateCartData } from "../../Redux/Actions";
import logo from "../../assets/images/logo.png";
import ProductListLight from "../../assets/images/ProductListLightT.svg";
import BlogLight from "../../assets/images/BlogLight.svg";
import FaqLight from "../../assets/images/FaqLight.svg";
import ProfileLight from "../../assets/images/ProfileLight.svg";
import AboutLight from "../../assets/images/AboutLight.svg";
import ContactLight from "../../assets/images/ContactLightT.svg";
import WorkLight from "../../assets/images/work.svg";
import CartModal from "../CartModal/CartModal";
import CategoryMobile from "../CategoryMobile/CategoryMobile";
import BaseModal from "../../Base/BaseModal/BaseModal";
import Spinner from "../Spinner/Spinner";
import "./Header.scss";
import "./Responsive.scss";
import SubCategory from "../SubCategory/SubCategory";

const Header = (props) => {
  let menuLinks;
  let topHeader;
  let menuItem;
  let searchBox = useRef();

  const [searchIcon, setSearchIcon] = useState(true);
  const [menuHumburger, setMenuHumburger] = useState(false);
  const [social, setSocial] = useState([]);
  const [contact, setContact] = useState();
  const [search, setSearch] = useState("");
  const [showOtpField, setshowOtpField] = useState(false);
  const [cartModal, setCartModal] = useState(false);
  const [showSupplierModal, setshowSupplierModal] = useState(false);
  const [otpPhoneNumber, setOtpPhoneNumber] = useState(null);
  const [otpCode, setOtpCode] = useState(null);
  const [showSupplierSpinner, setShowSupplierSpinner] = useState(false);
  const [showOtpSpinner, setShowOtpSpinner] = useState(false);
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  useEffect(async () => {
    // topHeader = document.querySelector(".topHeader");
    // menuLinks = document.querySelector(".menuLinks");
    // menuItem = document.querySelectorAll(".menuItem");
    // let lastScroll = 0;
    // let xt1;
    // let xt2;
    // window.addEventListener("scroll", () => {
    //   let currentScroll = window.pageYOffset;
    //   if (currentScroll <= 0) {
    //     menuLinks.style.display = "flex";
    //     topHeader.style.boxShadow = "none";
    //     return;
    //   }
    //   if (currentScroll > lastScroll && !Array.from(menuItem).some(({ classList }) => classList.contains("hovered"))) {
    //     xt1 = setTimeout(() => {
    //       // menuLinks.style.display = "none";
    //       // menuLinks.style.height = "0px";
    //       menuLinks.style.transform = "translateY(-60px)";
    //       topHeader.style.boxShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.1)";
    //     }, 200);
    //   } else {
    //     xt2 = setTimeout(() => {
    //       // menuLinks.style.display = "flex";
    //       // menuLinks.style.height = "40px";
    //       menuLinks.style.transform = "translateY(0px)";
    //       topHeader.style.boxShadow = "none";
    //     }, 200);
    //   }
    //   lastScroll = currentScroll;

    //   return () => {
    //     clearTimeout(xt1);
    //     clearTimeout(xt2);
    //   };
    // });

    if (menuItem) {
      menuItem.forEach(function (el) {
        el.addEventListener("mouseenter", (e) => {
          e.target.classList.add("hovered");
        });
        el.addEventListener("mouseleave", (e) => {
          e.target.classList.remove("hovered");
        });
      });
    }

    if (user.length > 0) {
      await compareCartData();
      await checkUserAuthenticaton();
    }

    await getSocail();
    await getContact();
  }, []);

  const checkUserAuthenticaton = () => {
    if (document.cookie.indexOf("rememberMe") > -1) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/account/checkAuthorize", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 401) {
            if (dispatch(removeUser(user[0]))) {
              dispatch(emptyCart(cart));
              document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      if (dispatch(removeUser(user[0]))) {
        dispatch(emptyCart(cart));
        document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
      }
    }
  };

  const compareCartData = async () => {
    await axios
      .get("/orders/showorder", {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + user[0]?.token,
        },
      })
      .then((result) => {
        if (result != undefined) {
          if (result.status === 200) {
            const cartOrderDetails = result.data.data.orderDetail;
            let obj = [];
            cartOrderDetails.map((item) => {
              obj.push({
                id: item.productId,
                productImage: item.image,
                providerId: item.providerId,
                description: "",
                productName: item.title,
                isApproved: item.isApproved,
                unitPrice: item.price,
                weight: "",
                pageCount: "",
                orderDetailId: item.orderDetailId,
                count: item.count,
              });
            });
            dispatch(updateCartData(obj));
          } else {
            dispatch(emptyCart(cart));
          }
        } else {
          dispatch(emptyCart());
          return false;
        }
      })
      .catch((error) => {
        console.log("err: " + error);
      });
  };

  const getSocail = () => {
    axios
      .get(
        "/Contact/GetSocialMedia",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setSocial(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getContact = () => {
    axios
      .get(
        "/Contact/GetHeaderContact",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setContact(result?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const openSearchBox = (e) => {
    setSearchIcon(false);
    searchBox.current.style.display = "flex";
    searchBox.current.style.transform = "translateY(0)";
  };

  const closeSearchBox = (e) => {
    setSearchIcon(true);
    searchBox.current.style.display = "none";
    searchBox.current.style.transform = "translateY(-100%)";
  };

  const searchHandler = (e) => {
    setSearch(e.target.value);
  };

  const searchClickedHandler = () => {
    props.history.replace({
      pathname: `/products`,
      state: { searchKey: search, categoryId: null },
    });
  };

  const searchOnEnter = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      props.history.replace({
        pathname: `/products`,
        state: { searchKey: search, categoryId: null },
      });
    }
  };

  const goToLoginHandler = (type) => {
    if (type === "login") {
      props.history.push({
        pathname: "/login",
        state: { prevPath: props.location.pathname },
      });
    } else {
      props.history.push("/profile");
    }
  };

  const backHandler = () => {
    props.history.goBack();
  };

  const cartModalHandler = () => {
    setCartModal(true);
  };
  const closeCartModal = () => {
    setCartModal(false);
  };

  const changeAddressHandler = () => {
    props.history.push({
      pathname: "/changeAddress",
      state: { chooseAddress: true },
    });
    setCartModal(false);
  };

  const showCartHandler = () => {
    props.history.push("/cart");
    setCartModal(false);
  };

  const openMenuHamburger = () => {
    setMenuHumburger(!menuHumburger);
    let menuHumburgerBox = document.querySelector(".menuHumburgerBox");
    if (menuHumburgerBox.classList.contains("active")) {
      menuHumburgerBox.classList.remove("active");
    } else {
      menuHumburgerBox.classList.add("active");
    }
  };

  const gotoLink = (link) => {
    openMenuHamburger();
    props.history.push(link);
  };

  return (
    <header>
      {cartModal && (
        <CartModal
          title="انتخاب آدرس"
          closeCartModal={closeCartModal}
          showCartHandler={showCartHandler}
          changeAddressHandler={changeAddressHandler}
        />
      )}
      <div className="topHeader mobile">
        <div className="logo">
          <FaBars className="menuHumburger" onClick={openMenuHamburger} />
          <div className="menuHumburgerBox">
            <div className="header">
              <Link to="/">
                <img src={logo} alt={`IranLegalo | ${Config.helmetTitle}`} className="mLogo" />
              </Link>
              <FaTimes className="close" onClick={openMenuHamburger} />
            </div>
            <div className={props.activePage === "home" ? "menuItem active" : "menuItem"}>
              <svg
                className="itemImage"
                width="20"
                height="20"
                viewBox="0 0 19 21"
                fill="#999999"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.6522 6.08732C18.3642 6.65997 18.7822 7.52148 18.7913 8.43515L18.7826 16.4091C18.7826 18.575 17.0268 20.3308 14.8609 20.3308H13.1217C12.0734 20.3308 11.2222 19.4835 11.2174 18.4351V14.8351C11.2174 14.5566 10.9916 14.3308 10.713 14.3308H8.10435C7.96907 14.3308 7.83945 14.3851 7.74461 14.4816C7.64977 14.5781 7.59767 14.7086 7.6 14.8438V16.2178C7.6 16.65 7.24961 17.0004 6.81739 17.0004C6.38517 17.0004 6.03478 16.65 6.03478 16.2178V14.8438C6.03478 14.2927 6.25374 13.764 6.64349 13.3743C7.03324 12.9845 7.56185 12.7656 8.11304 12.7656H10.7217C11.8661 12.7704 12.7913 13.6994 12.7913 14.8438V18.4351C12.7913 18.6176 12.9392 18.7656 13.1217 18.7656H14.9043C16.201 18.7656 17.2522 17.7144 17.2522 16.4178V8.45254C17.2458 8.01128 17.0415 7.59624 16.6957 7.32211L10.687 2.5308C9.92926 1.90701 8.83595 1.90701 8.07826 2.5308L6.14783 3.97428C5.79004 4.23121 5.29172 4.14946 5.03478 3.79167C4.77785 3.43389 4.85961 2.93556 5.21739 2.67863L7.12174 1.29602C8.44214 0.234661 10.3231 0.234661 11.6435 1.29602L17.6522 6.08732ZM3.92174 18.7569H7.92174V18.7743C8.35396 18.7743 8.70435 19.1247 8.70435 19.5569C8.70435 19.9891 8.35396 20.3395 7.92174 20.3395H3.92174C1.75781 20.3347 0.00478219 18.5817 0 16.4178V8.45254C0.0138353 7.53212 0.445876 6.66804 1.17391 6.10471L1.89565 5.56558C2.23552 5.40536 2.64129 5.50929 2.86229 5.81317C3.08329 6.11704 3.05714 6.53509 2.8 6.80906L2.09565 7.3308C1.76191 7.60807 1.56776 8.01866 1.56522 8.45254V16.4091C1.57474 17.7052 2.62562 18.7522 3.92174 18.7569Z"
                  fill="#999999"
                  strokeWidth="3px"
                />
              </svg>
              <a href="/" className="title">
                خانه
              </a>{" "}
            </div>
            <div className={props.activePage === "home" ? "menuItem active" : "menuItem"}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="itemImage"
                width="20"
                height="20"
                viewBox="0 0 19 21"
                fill="#999999"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.4038 13.7469L18.6483 7.87507C18.1651 5.238 16.4169 4.35898 14.941 4.35898C14.7194 2.43528 13.3911 0.820316 11.5472 0.232477C9.70319 -0.355361 7.68609 0.193149 6.39313 1.63401C6.20481 1.83657 6.1388 2.12426 6.21996 2.38873C6.30112 2.65319 6.51712 2.85424 6.7866 2.91614C7.05608 2.97804 7.33809 2.8914 7.5264 2.68884V2.60093C8.76885 1.21325 10.9 1.09522 12.2879 2.33723C12.872 2.86621 13.2566 3.58001 13.3773 4.35898H5.13687C3.72247 4.35898 2.00938 5.238 1.42957 7.91902L1.20994 9.23755C1.16827 9.64194 1.44654 10.0096 1.84686 10.0791C2.24718 10.1485 2.63293 9.89608 2.72976 9.50126L2.9406 8.20909C3.26565 6.74113 4.08266 5.86211 5.13687 5.86211H14.941C16.0479 5.86211 16.8649 6.74113 17.1285 8.14756L17.8752 13.9579C18.1036 15.5401 17.8752 16.7004 17.3042 17.3949C16.7331 18.0893 15.635 18.4233 14.0449 18.4233H6.03294C4.8627 18.5023 3.71279 18.088 2.86153 17.2806C2.1687 16.3219 1.9281 15.1086 2.20265 13.9579C2.2633 13.538 1.97225 13.1483 1.55256 13.0877C1.13287 13.027 0.743487 13.3182 0.682839 13.7381C0.237506 15.3284 0.617375 17.0362 1.69476 18.2874C2.77214 19.5386 4.40397 20.1671 6.04173 19.9616H14.0449C16.1182 19.9616 17.5589 19.4518 18.4375 18.4057C19.316 17.3597 19.6937 15.7863 19.4038 13.7469ZM12.5075 10.0287C12.6172 10.0706 12.7329 10.0943 12.8502 10.099C13.0819 10.0957 13.3029 10.0009 13.4651 9.83529C13.5593 9.75845 13.6319 9.65851 13.6759 9.54521C13.7251 9.44089 13.7492 9.32649 13.7462 9.21118C13.7553 9.15293 13.7553 9.09363 13.7462 9.03538C13.7381 8.97715 13.7203 8.9207 13.6935 8.86836C13.6797 8.81286 13.6526 8.76156 13.6145 8.71893C13.5469 8.62653 13.4671 8.54373 13.3773 8.4728C13.2765 8.41198 13.1668 8.36748 13.0522 8.34095C12.9395 8.3147 12.8223 8.3147 12.7096 8.34095C12.6517 8.35047 12.5955 8.36823 12.5427 8.39369C12.4867 8.41293 12.4335 8.43953 12.3845 8.4728L12.2528 8.58707C12.2084 8.62272 12.1724 8.66774 12.1473 8.71893L12.0595 8.86836V9.03538C12.0506 9.09364 12.0506 9.15292 12.0595 9.21118C12.0534 9.32581 12.0745 9.44026 12.121 9.54521C12.187 9.74793 12.3244 9.91975 12.5075 10.0287ZM8.14136 9.21997C8.14136 9.70544 7.74804 10.099 7.26285 10.099C7.03726 10.0911 6.82334 9.99672 6.66547 9.83529C6.58233 9.75247 6.51662 9.65384 6.4722 9.54521C6.43019 9.43892 6.4093 9.32546 6.4107 9.21118C6.40164 9.15293 6.40164 9.09363 6.4107 9.03538C6.41884 8.97715 6.43666 8.9207 6.46341 8.86836C6.48095 8.81436 6.5077 8.7638 6.54248 8.71893C6.56748 8.66774 6.60348 8.62272 6.6479 8.58707C6.68636 8.54558 6.73077 8.51003 6.77967 8.48159C6.82452 8.4468 6.87505 8.42003 6.92902 8.40248C6.98133 8.37571 7.03775 8.35789 7.09593 8.34974C7.20863 8.32349 7.32585 8.32349 7.43855 8.34974C7.49674 8.35789 7.55316 8.37571 7.60547 8.40248C7.65944 8.42003 7.70997 8.4468 7.75481 8.48159C7.80745 8.51196 7.8549 8.55053 7.89538 8.59586C7.93979 8.63151 7.97579 8.67653 8.0008 8.72772C8.03493 8.77451 8.06436 8.82456 8.08865 8.87715L8.14136 9.04417C8.14613 9.10267 8.14613 9.16147 8.14136 9.21997Z"
                  fill="#999999"
                />
              </svg>
              <a href="/markets" className="title">
                مراکز ارائه خدمات
              </a>{" "}
            </div>
            <div className={props.activePage === "product" ? "menuItem active" : "menuItem"}>
              <img className="itemImage" src={ProductListLight} alt="Product List" />
              <a href="/products" className="title">
                همه محصولات
              </a>{" "}
            </div>
            {/* <div className={props.activePage === "product" ? "menuItem active" : "menuItem"}>
              <img className="itemImage" src={ProductListLight} alt="Product List" />
              <span onClick={() => gotoLink("/products")} className="title">
                مراکز ارائه خدمات
              </span>
            </div> */}
            <div className={props.activePage === "blog" ? "menuItem active" : "menuItem"}>
              <img className="itemImage" src={BlogLight} alt="blog" />
              <a href="/blog" className="title">
                بلاگ
              </a>{" "}
            </div>
            <div className={props.activePage === "faq" ? "menuItem active" : "menuItem"}>
              <img className="itemImage" src={FaqLight} alt="faq" />
              <a href="/faq" className="title">
                سوالات متداول
              </a>{" "}
            </div>
            <div className={props.activePage === "about" ? "menuItem active" : "menuItem"}>
              <img className="itemImage" src={AboutLight} alt="about" />
              <a href="/aboutus" className="title">
                درباره ما
              </a>{" "}
            </div>
            <div className={props.activePage === "contact" ? "menuItem active" : "menuItem"}>
              <img className="itemImage" src={ContactLight} alt="contact" />
              <a href="/contactus" className="title">
                تماس با ما
              </a>{" "}
            </div>
            <hr color="#1F3BCD" style={{ width: "100%", border: "none", borderTop: "1px dashed #1F3BCD" }} />
            {!user[0]?.token && (
              <div className={props.activePage === "product" ? "menuItem active" : "menuItem providerBtn"}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="itemImage"
                  width="16"
                  height="21"
                  viewBox="0 0 16 21"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.05836 5.85387C4.05836 3.69392 5.82642 1.93696 8 1.93696C10.1736 1.93696 11.9416 3.69392 11.9416 5.85387C11.9416 8.01281 10.1736 9.76977 8 9.76977C5.82642 9.76977 4.05836 8.01281 4.05836 5.85387ZM2.61233 5.85387C2.61233 8.80479 5.02943 11.2067 8 11.2067C10.9706 11.2067 13.3867 8.80479 13.3867 5.85387C13.3867 2.90194 10.9706 0.5 8 0.5C5.02943 0.5 2.61233 2.90194 2.61233 5.85387ZM6.97761 20.485C7.3127 20.495 7.65384 20.5 8 20.5C11.4345 20.5 16 20.119 16 16.8301C16 13.1392 9.97836 13.1392 8 13.1392C4.56553 13.1392 0 13.5202 0 16.8101C0 17.7951 0.460881 19.124 2.6566 19.863C3.03597 19.993 3.44453 19.788 3.57333 19.413C3.70113 19.038 3.49887 18.631 3.1205 18.504C1.61811 17.9981 1.44503 17.2951 1.44503 16.8101C1.44503 15.3271 3.65082 14.5751 8 14.5751C12.3492 14.5751 14.555 15.3341 14.555 16.8301C14.555 18.3121 12.3492 19.063 8 19.063C7.66792 19.063 7.34088 19.059 7.01887 19.05C6.63245 19.053 6.2883 19.351 6.27723 19.747C6.26516 20.144 6.57912 20.475 6.97761 20.485Z"
                    fill="#1F3BCD"
                  />
                </svg>
                <Link to="/login" className="title" onClick={() => openMenuHamburger()}>
                  ورود / ثبت نام کاربر
                </Link>
              </div>
            )}
            <div className={props.activePage === "product" ? "menuItem active" : "menuItem providerBtn"}>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                className="itemImage"
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.05836 5.85387C4.05836 3.69392 5.82642 1.93696 8 1.93696C10.1736 1.93696 11.9416 3.69392 11.9416 5.85387C11.9416 8.01281 10.1736 9.76977 8 9.76977C5.82642 9.76977 4.05836 8.01281 4.05836 5.85387ZM2.61233 5.85387C2.61233 8.80479 5.02943 11.2067 8 11.2067C10.9706 11.2067 13.3867 8.80479 13.3867 5.85387C13.3867 2.90194 10.9706 0.5 8 0.5C5.02943 0.5 2.61233 2.90194 2.61233 5.85387ZM6.97761 20.485C7.3127 20.495 7.65384 20.5 8 20.5C11.4345 20.5 16 20.119 16 16.8301C16 13.1392 9.97836 13.1392 8 13.1392C4.56553 13.1392 0 13.5202 0 16.8101C0 17.7951 0.460881 19.124 2.6566 19.863C3.03597 19.993 3.44453 19.788 3.57333 19.413C3.70113 19.038 3.49887 18.631 3.1205 18.504C1.61811 17.9981 1.44503 17.2951 1.44503 16.8101C1.44503 15.3271 3.65082 14.5751 8 14.5751C12.3492 14.5751 14.555 15.3341 14.555 16.8301C14.555 18.3121 12.3492 19.063 8 19.063C7.66792 19.063 7.34088 19.059 7.01887 19.05C6.63245 19.053 6.2883 19.351 6.27723 19.747C6.26516 20.144 6.57912 20.475 6.97761 20.485Z"
                  fill="#1F3BCD"
                />
              </svg> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="21"
                viewBox="0 0 20 19"
                fill="none"
                className="itemImage"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95693 5.11849C3.95693 5.53115 3.62096 5.86607 3.20698 5.86607C2.79301 5.86607 2.45703 5.53115 2.45703 5.11849C2.45703 2.29659 4.75988 0 7.59169 0C10.4225 0 12.7253 2.29659 12.7253 5.11849C12.7253 7.94038 10.4225 10.237 7.59169 10.237C6.43177 10.237 5.33884 9.86517 4.4329 9.16144C4.10592 8.90726 4.04693 8.43778 4.30191 8.11183C4.55689 7.78688 5.02686 7.72807 5.35384 7.98125C5.9948 8.47865 6.76874 8.7418 7.59169 8.7418C9.59555 8.7418 11.2254 7.11604 11.2254 5.11849C11.2254 3.12093 9.59555 1.49518 7.59169 1.49518C5.58682 1.49518 3.95693 3.12093 3.95693 5.11849ZM13.2693 8.38724C13.2693 7.97457 13.6053 7.63965 14.0193 7.63965C15.4242 7.63965 16.5661 6.50033 16.5661 5.10084C16.5661 3.70136 15.4242 2.56203 14.0193 2.56203C13.6053 2.56203 13.2693 2.22711 13.2693 1.81445C13.2693 1.40178 13.6053 1.06686 14.0193 1.06686C16.2511 1.06686 18.066 2.87702 18.066 5.10084C18.066 7.32566 16.2511 9.13483 14.0193 9.13483C13.6053 9.13483 13.2693 8.79991 13.2693 8.38724ZM17.3144 11.4618C18.5793 11.71 19.4123 12.2204 19.7743 12.9779C20.0752 13.6089 20.0752 14.3306 19.7743 14.9615C19.4173 15.7121 18.5853 16.2255 17.3024 16.4876C17.2514 16.4976 17.2014 16.5026 17.1504 16.5026C16.8025 16.5026 16.4895 16.2593 16.4175 15.9055C16.3345 15.5008 16.5955 15.1061 17.0015 15.0233C17.7644 14.8678 18.2814 14.6117 18.4194 14.3206C18.5253 14.0973 18.5253 13.8421 18.4204 13.6209C18.2794 13.3278 17.7644 13.0736 17.0065 12.9251C16.4945 12.8115 15.9885 12.7387 15.4836 12.7048C15.0706 12.6759 14.7586 12.3201 14.7876 11.9084C14.8156 11.4947 15.1806 11.1917 15.5865 11.2126C16.1655 11.2525 16.7465 11.3362 17.3144 11.4618ZM7.59149 11.9178C5.71361 11.9178 0 11.9178 0 15.4694C0 16.2668 0.316979 17.3742 1.82388 18.1119C2.28885 18.3381 2.85281 18.5225 3.49976 18.6601C3.90474 18.7488 4.30271 18.4886 4.3887 18.085C4.4757 17.6803 4.21672 17.2835 3.81174 17.1978C3.28478 17.0862 2.83781 16.9416 2.48383 16.7682C1.61189 16.3416 1.4999 15.8502 1.4999 15.4694C1.4999 13.7689 4.81267 13.413 7.59149 13.413C11.6332 13.413 13.6821 14.0988 13.6821 15.4495C13.6821 17.149 10.3703 17.5048 7.59149 17.5048C7.17752 17.5048 6.84154 17.8397 6.84154 18.2524C6.84154 18.6661 7.17752 19 7.59149 19C9.46836 19 15.182 19 15.182 15.4495C15.182 12.2837 10.8503 11.9178 7.59149 11.9178Z"
                  fill="#1F3BCD"
                />
              </svg>
              <a href="https://panel.sadrayar.ir" className="title">
                ورود / ثبت نام نماینده
              </a>
            </div>
          </div>
          {menuHumburger && <div className="menuOverlay" onClick={openMenuHamburger} />}
        </div>
        <div className="menu">
          {searchIcon ? (
            <FaSearch className="close" onClick={(e) => openSearchBox(e)} />
          ) : (
            <FaTimes className="close" onClick={(e) => closeSearchBox(e)} />
          )}
          <div className="menuTitle" onClick={backHandler}>
            <FaArrowLeft className="back" />
          </div>
        </div>
        <div className="headerlinksItem">
          <HeaderCartBox cartModalHandler={cartModalHandler} />
        </div>
        <div className="searchBox mobile" ref={searchBox}>
          <div className="formBox">
            <div className="formGroup">
              <input
                className="searchInput"
                value={search}
                onChange={(e) => searchHandler(e)}
                type="text"
                onKeyPress={searchOnEnter}
                placeholder="جستجوی محصول..."
              />
              <button className="btnSearch" onClick={searchClickedHandler}>
                <FaSearch />
              </button>
            </div>
          </div>
        </div>
        <div className="headerLinks">
          <div className="headerlinksItem headerLinksLogo">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt={`IranRegalo | ${Config.helmetTitle}`} />
              </Link>
            </div>
          </div>
          <div className="headerlinksItem">
            {user.length > 0 && user[0]?.token !== "" ? (
              <div className="linksParent">
                <img src={ProfileLight} alt="profile" className="profileIcon" />
                <span className="userInfo" onClick={() => goToLoginHandler("profile")}>
                  حساب کاربری
                </span>
              </div>
            ) : (
              <div className="linksParent">
                {/* <img src={ProfileLight} alt="profile" className="profileIcon" /> */}
                <span className="userInfo" style={{ marginRight: "0" }} onClick={() => goToLoginHandler("login")}>
                  ثبت نام / ورود کاربر
                </span>
              </div>
            )}
          </div>
          <div className="headerlinksItem">
            <div className="linksParent">
              <a href="https://panel.sadrayar.ir" className="userInfo" style={{ marginRight: "0" }}>
                ثبت نام / ورود نماینده
              </a>
            </div>
          </div>
          {/* <div className="headerlinksItem">
            <div className="linksParent">
              <select
                className="langSelect"
                onChange={(e) => {
                  if (e.target.value === "fa") {
                    props.history.push(`/`);
                  } else {
                    props.history.push(`/commingSoon/${e.target.value}`);
                  }
                }}
              >
                <option disabled>زبان</option>
                <option value="fa" selected>
                  fa
                </option>
                <option value="tr">tr</option>
                <option value="ar">ar</option>
                <option value="en">en</option>
              </select>
            </div>
          </div> */}
        </div>
      </div>
      <div className="menuLinks">
        <div className="menuItems">
          <div className="menuItem product">{props.showCategory && <Category />}</div>
        </div>
      </div>
    </header>
  );
};

export default React.memo(withRouter(Header));
